import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { IIconProps } from "../icon";

export const LactoseIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  const { t } = useTranslation();

  return (
    <svg viewBox="0 0 72 72" {...rest}>
      <title>{t("icons.lactose")}</title>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons/Big/Laktose">
          <g
            id="Group"
            transform="translate(15.269390, 8.098267)"
            stroke={props.fill}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path
              d="M24.2678242,57.4556758 L3.75910688,55.8957949 C3.08968381,55.8451188 2.46787218,55.5313504 2.03047648,55.0235217 C1.59308077,54.515693 1.37593398,53.8554072 1.42681046,53.1879333 L4.28313248,15.8518613 L27.3163527,17.6033901 L24.2678242,57.4556758 Z"
              id="Path"
              transform="translate(14.367939, 36.653769) rotate(-4.000000) translate(-14.367939, -36.653769) "
            ></path>
            <path
              d="M33.2777273,7.77342534 L10.2406821,6.02189656 L10.4615761,3.13478215 C10.5684107,1.74506352 11.7844509,0.704552763 13.1782855,0.81021645 L31.1634561,2.17844934 C32.5570804,2.28447479 33.6007554,3.49670777 33.4947963,4.88631094 L33.2777273,7.77342534 Z"
              id="Path"
              transform="translate(21.871442, 4.288128) rotate(-4.000000) translate(-21.871442, -4.288128) "
            ></path>
            <polygon
              id="Path"
              transform="translate(18.174848, 11.787644) rotate(-4.000000) translate(-18.174848, -11.787644) "
              points="25.5910529 17.277261 2.55783273 15.5257322 10.7586421 6.29802636 33.7918623 8.04955515"
            ></polygon>
            <path
              d="M36.6955749,57.0777155 L24.3159482,56.1356848 L27.3644767,16.2805387 L42.26765,17.4170778 L39.411328,54.7531498 C39.3049935,56.1427245 38.0892278,57.1833667 36.6955749,57.0777155 Z"
              id="Path"
              transform="translate(33.291799, 36.682819) rotate(-4.000000) translate(-33.291799, -36.682819) "
            ></path>
            <polygon
              id="Path"
              transform="translate(33.107053, 12.189609) rotate(-4.000000) translate(-33.107053, -12.189609) "
              points="33.8562761 7.00891629 40.55864 17.3703008 25.6554667 16.2366221"
            ></polygon>
            <polygon
              id="Path"
              transform="translate(14.280858, 35.983391) rotate(-89.638000) translate(-14.280858, -35.983391) "
              points="3.43953226 24.4315886 25.1170926 24.4363796 25.122183 47.5351928 3.44462264 47.5304019"
            ></polygon>
            <polygon
              id="Path"
              transform="translate(33.302302, 36.098925) rotate(-89.638000) translate(-33.302302, -36.098925) "
              points="22.4618745 28.6230743 44.1394349 28.6278652 44.1427288 43.5747748 22.4651684 43.5699839"
            ></polygon>
            <path
              d="M18.7244231,32.4083816 C19.457022,31.6823925 21.3932557,31.5667821 23.1139212,33.0899894 C23.1139212,33.0899894 21.7717467,34.9397548 20.4761215,34.9397548 C19.676039,34.9587413 18.9388775,34.5126383 18.5919789,33.799541"
              id="Path"
            ></path>
            <path
              d="M10.3250261,32.4083816 C10.3659651,31.9233218 10.6021541,31.4748217 10.9805969,31.1635158 C13.1717169,29.9049775 15.8771781,29.9049775 18.0682981,31.1635158 C18.6191327,31.4571989 18.8890085,32.739323 18.7216523,33.3354559 L17.1445141,38.9384478 C17.0190101,39.3867461 16.7776039,39.7950057 16.4440563,40.1230428"
              id="Path"
            ></path>
            <path
              d="M12.6037304,40.121947 C12.2709734,39.7939206 12.0300037,39.3861309 11.904381,38.9384478 L10.4580244,33.8000889"
              id="Path"
            ></path>
            <path
              d="M12.7805073,39.0085811 C12.5040678,39.3655966 12.4566965,39.846861 12.6583253,40.2498789 C12.8599541,40.6528967 13.2755844,40.9077126 13.7303368,40.9071121 L15.3185582,40.9071121 C15.7730151,40.9073392 16.1882528,40.6526265 16.3898915,40.24994 C16.5915303,39.8472534 16.5446515,39.366328 16.2689419,39.009129 L16.2440047,38.9773499 C15.8295625,38.4553912 15.1956013,38.1505802 14.5244475,38.1505802 C13.8532937,38.1505802 13.2193325,38.4553912 12.8048903,38.9773499 L12.7805073,39.0085811 Z"
              id="Path"
            ></path>
            <path
              d="M12.9761256,33.5211992 C12.7624731,33.5209779 12.5697335,33.6480585 12.4878169,33.8431602 C12.4059002,34.038262 12.4509465,34.2629439 12.6019424,34.4123955 C12.7529383,34.561847 12.980133,34.6066217 13.1775438,34.5258328 C13.3749545,34.4450439 13.5036855,34.2546093 13.5036855,34.0433637 C13.5033808,33.7553191 13.2674519,33.5218032 12.9761256,33.5211992 L12.9761256,33.5211992 Z"
              id="Path"
            ></path>
            <path
              d="M16.0334241,33.5211995 C15.7417547,33.5211995 15.50531,33.7549804 15.50531,34.0433637 C15.50531,34.3317471 15.7417547,34.565528 16.0334241,34.565528 C16.3250934,34.565528 16.5615382,34.3317471 16.5615382,34.0433637 C16.5609285,33.7552305 16.3248405,33.5218023 16.0334241,33.5211995 L16.0334241,33.5211995 Z"
              id="Path"
            ></path>
            <line x1="13.831748" y1="39.3488371" x2="13.831748" y2="39.8874388" id="Path"></line>
            <line x1="15.1090859" y1="39.3488371" x2="15.1090859" y2="39.8874388" id="Path"></line>
            <path
              d="M5.93497383,33.0905373 C5.93497383,33.0905373 7.27714836,34.9403027 8.57277349,34.9403027 C9.65281416,34.9799061 10.5661991,34.1574494 10.6270431,33.0905373 C10.6270431,31.8604653 8.10838775,31.1662553 5.93497383,33.0905373 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
